import defaultActions from './defaultReduxActions';

const actions = defaultActions({ namespace: 'weights' });

export const { find, create, get, patch, reducer, remove } = actions;

export default reducer;
